import set from 'lodash/set'

export default function (config, migrateVersion) {
  set(config, '_version', migrateVersion)
  return config
}
